import { combineEpics } from "redux-observable";

import { wrapEpic } from "lib/utils/epic";
import app from "modules/app/index";
import auth from "modules/auth/index";
import affiliate from "modules/affiliate/index";
import calendar from "modules/calendar/index";
import accommodation from "modules/accommodation/index";
import customers from "modules/customers/index";
import dashboard from "modules/dashboard/index";
import orders from "modules/orders/index";
import products from "modules/products/index";
import agents from "modules/agents/index";
import finances from "modules/finances/index";
import reviews from "modules/reviews/index";
import settings from "modules/settings/index";
import synchronization from "modules/synchronization/index";

export default combineEpics(
  ...[
    app.epic,
    auth.epic,
    affiliate.epic,
    calendar.epic,
    accommodation.epic,
    customers.epic,
    dashboard.epic,
    orders.epic,
    products.epic,
    agents.epic,
    finances.epic,
    reviews.epic,
    settings.epic,
    synchronization.epic,
  ].map(wrapEpic)
);



// WEBPACK FOOTER //
// ./src/app/RootEpic.js